import React from 'react';
import './About.css';

const About = () => {
  return (
    <main className="about-page">
      <div className="about-container">
        <section className="about-section">
          <h1 className="about-title">ABOUT US</h1>
          <div className="about-section-wrapper">
            <div className="about-image-container">
              <img 
                src={`${process.env.PUBLIC_URL}/images/about-1.jpg`}
                alt="Ribbon Cutting Ceremony"
                className="about-image"
                onError={(e) => {
                  // Try alternative filename
                  if (!e.target.src.includes('about_us')) {
                    e.target.src = `${process.env.PUBLIC_URL}/images/about_us.jpeg`;
                  } else {
                    e.target.style.display = 'none';
                  }
                }}
              />
            </div>
            <div className="about-content">
              <p>
                Educational Torch of Pragati Vidyalaya which has been glowing for the past 13 years 
                and with time has brightened and become an empowering "Light of Knowledge" that is 
                constantly spreading, speaking and above all imparting valuable learning to all our students.
              </p>
              <p>
                We follow a relentless path which inculcates in each and every student not only deep 
                knowledge but also instills values that encourage them all to give importance to our 
                age old culture, tradition, discipline, and manners so that they are well trained to 
                step out into the world as exemplary citizens of our proud country. We wish them all 
                Good Luck for their brighter and happier future.
              </p>
            </div>
          </div>
        </section>

        <section className="pragati-section">
          <h2 className="pragati-title">PRAGATI VIDYALAYA</h2>
          <div className="pragati-section-wrapper">
            <div className="pragati-image-container">
              <img 
                src={`${process.env.PUBLIC_URL}/images/building2.jpeg`}
                alt="Pragati Vidyalaya School Building"
                className="pragati-image"
                onError={(e) => {
                  // Try alternative filenames
                  if (!e.target.src.includes('about_us')) {
                    e.target.src = `${process.env.PUBLIC_URL}/images/about_us.jpeg`;
                  } else if (!e.target.src.includes('building1')) {
                    e.target.src = `${process.env.PUBLIC_URL}/images/building1.jpeg`;
                  } else {
                    e.target.style.display = 'none';
                  }
                }}
              />
            </div>
            <div className="pragati-content">
              <p>
                We follow a relentless path which inculcates in each and every student not only deep 
                knowledge but also instills values that encourage them all to give importance to our 
                age-old culture, tradition, discipline, and manners so that they are well trained to 
                step out into the world as exemplary citizens of our proud country. We wish them all 
                Good Luck for their brighter and happier future.
              </p>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

export default About;

